import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { createUserTransactions } from 'src/axious/user-transactions'
import { TransactionContainer } from 'src/components/ui'
import { handleAxiosError } from 'src/utils/errorHandling'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

interface Props {
  className?: string
}

const WithdrawalStarsPage: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const userId = useGlobalStore((state) => state.user?.id) || 0

  const onWithdrawalStars = async (value: string) => {
    try {
      await createUserTransactions({
        amount_stars: +value,
        commission: 0,
        type: 'WITHDRAWAL',
        wallet: 'USDT',
        withdrawalType: 'USDT',

        recipient: +userId,
        gift_id: '',
      })

      navigate('/withdrawal/success?type=withdrawal&withdrawal_type=in_acc')
    } catch (error) {
      const errorMessage = handleAxiosError(error)
      console.log('errorMessage', errorMessage)
    }
  }

  return (
    <div className={className}>
      {/* <TransactionContainer
        typeOfHeader='back'
        title={t('withdrawal_page.stars.title')}
        subtitle={t('withdrawal_page.stars.subtitle')}
        buttonText={t('withdrawal_page.stars.button_text')}
        onTransferStars={onWithdrawalStars}

      /> */}
    </div>
  )
}

export default WithdrawalStarsPage
